<template>
  <v-skeleton-loader
    v-if="firstLoad"
    :loading="loading"
    type="table"
    :types="skeleton_types"
  ></v-skeleton-loader>
</template>

<script>
export default {
  name: "SkeletonTable",
  props: {
    loading: Boolean,
    firstLoad: Boolean,
    cols: Number,
    rows: Number
  },

  computed: {
    skeleton_types() {
      return {
        "table-heading": "heading, button",
        "table-thead": "heading@" + this.cols,
        "table-tbody": "table-row-divider@" + this.rows,
        "table-row": "table-cell@" + this.cols,
      }
    }
  }
};
</script>
